import { useEffect, useRef, useState, useCallback } from 'react';
import { WS_BASE } from '../utils/api';

var wsBase = WS_BASE;

export function useWebSocket(userId) {
  var wsRef = useRef(null);
  var reconnectTimer = useRef(null);
  var [connected, setConnected] = useState(false);
  var [partnerOnline, setPartnerOnline] = useState(false);
  var [partnerTyping, setPartnerTyping] = useState(false);
  var listenersRef = useRef({});
  var typingTimeout = useRef(null);

  var connect = useCallback(function () {
    if (!userId || wsRef.current) return;

    var url = WS_BASE + '/api/ws/chat';
    var ws = new WebSocket(url);
    wsRef.current = ws;

    ws.onopen = function () {
      setConnected(true);
    };

    ws.onmessage = function (event) {
      try {
        var data = JSON.parse(event.data);
        var type = data.type;

        if (type === 'presence') {
          setPartnerOnline(data.status === 'online');
        } else if (type === 'typing') {
          setPartnerTyping(true);
          clearTimeout(typingTimeout.current);
          typingTimeout.current = setTimeout(function () { setPartnerTyping(false); }, 3000);
        } else if (type === 'new_message') {
          if (listenersRef.current.onMessage) listenersRef.current.onMessage(data.message);
        } else if (type === 'notification') {
          if (listenersRef.current.onNotification) listenersRef.current.onNotification(data.notification);
        }
      } catch (e) { /* ignore parse errors */ }
    };

    ws.onclose = function () {
      setConnected(false);
      wsRef.current = null;
      reconnectTimer.current = setTimeout(function () { connect(); }, 3000);
    };

    ws.onerror = function () {
      ws.close();
    };
  }, [userId]);

  useEffect(function () {
    connect();
    return function () {
      clearTimeout(reconnectTimer.current);
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  }, [connect]);

  var sendTyping = useCallback(function () {
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify({ type: 'typing' }));
    }
  }, []);

  var onMessage = useCallback(function (fn) {
    listenersRef.current.onMessage = fn;
  }, []);

  var onNotification = useCallback(function (fn) {
    listenersRef.current.onNotification = fn;
  }, []);

  return { connected: connected, partnerOnline: partnerOnline, partnerTyping: partnerTyping, sendTyping: sendTyping, onMessage: onMessage, onNotification: onNotification };
}
